import React from 'react';

import {OutlinedTextFieldProps, TextField} from '@mui/material';

type Props = Partial<OutlinedTextFieldProps> & {
   variant?: 'outlined';
};
const Text = (props: Props) => {
   const {variant = 'outlined', placeholder, ...otherProps} = props;
   const label = placeholder;
   return <TextField disabled={true} label={label} variant={variant} fullWidth {...otherProps} />;
};

export default Text;
